import zhCN from "./zh-CN.json";
import En from "./EN.json";
import Tai from "./TAI.json";
let langConfig =  localStorage.getItem("lang-config");
if(!langConfig){
    langConfig = "zh-CN";
}

const langMap = {
    "zh-CN":zhCN,
    "EN":En,
    "TAI":Tai
}


export default {
    ...langMap[langConfig]
}

export const setLang = (lang)=>{
    localStorage.setItem("lang-config",lang);
    window.location.reload(true);
}

export const getLangName = ()=>{
    return langConfig;
}